import * as React from "react";
import Title from "src/components/common/Title";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import PbrProcessDocumentUploader, { IFileToUpload } from "src/components/common/PbrProcessDocumentUploader/PbrProcessDocumentUploader";
import { Col, Row, Select, notification, Form, Switch, Collapse, Spin, Modal, Tooltip, Divider } from "antd";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { FormComponentProps } from "antd/lib/form";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import { PbrInputCpf } from "src/components/common/PbrInputCpf/PbrInputCpf";
import { MonitorPrecatoriosQuoteResult } from "./MonitorPrecatoriosQuoteResult";
import { EstadosECidades } from "src/util/estados-cidades";
import { cpfCnpjValidator } from "src/util/cpfCnpjValidator";
import { ServiceContext } from "src/services/provider/Service.provider";
import { PbrInputMoney } from "src/components/common/PbrInputMoney/PbrInputMoney";
import "./precatorios.scss";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";
import { PSSComponent } from 'src/components/PricingComponents/PSSComponent/PSSComponent';
import { pssAbsoluteRequired, validatePssAndShowMessage } from 'src/util/pssHelper';
import { SelectCourtAndCourtType } from "src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourtAndCourtType";
import { EmptyNewPrecatorioRequest } from "src/services/mapper/EmptyNewPrecatorioRequest";
import { BaseDateComponent } from "src/components/PricingComponents/BaseDateComponent/BaseDateComponent";
import { IssueDateComponent } from "src/components/PricingComponents/IssueDateComponent/IssueDateComponent";
import { SelectNature } from 'src/components/common/SelectNature/SelectNature';
import { IPrecatorioCreateOrUpdateOfficerDto } from 'src/services/interfaces/IPrecatorioCreateNew';
import { useContext, useEffect, useState } from 'react';
import { objectPropsUpdate } from 'src/util/objectUtils';
import { SelecExpeditionType } from 'src/components/common/SelectExpeditionType/SelecExpeditionType';
import { PbrInputCNJ } from "src/components/common/PbrInputCNJ/PbrInputCNJ";
import { BirthDateComponent } from "src/components/PricingComponents/BirthDateComponent/BirthDateComponent";
import { PbrFormItem } from "src/components/common/PbrFormItem/PbrFormItem";
import { GetPersonType, PersonTypeEnum } from "src/util/GetPersonType";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import ViewCommissionModal from "src/components/common/CommissionView/ViewCommissionModal";
import { PbrInputPercentage } from "src/components/common/PbrInputPercentageCalculator/PbrInputPercentage";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import * as _ from "lodash";
import { PbrInputDate } from "src/components/common/PbrInputDate/PbrInputDate";
import * as moment from "moment";
import { IFeatureToggleConfig } from 'src/services/interfaces/IFeatureToggleConfig';

function MonitorPrecatoriosCreateOrUpdate(props: RouteComponentProps<any> & FormComponentProps) {
  const { quoteService, tradeService, precatorioService, tradeSearchService, pricingService, commonDomainService } = useContext(ServiceContext);

  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([{ nome: "" }]);
  const [quote, setQuote] = useState<IQuote>(null);
  const [precatorioRequest, setPrecatorioRequest] = useState<IPrecatorioCreateOrUpdateOfficerDto>(EmptyNewPrecatorioRequest);
  const [invalidCpfCnpj, setInvalidCpfCnpj] = useState(false);
  const [isHonorarios, setIsHonorarios] = useState(false);
  const [activePanel, setActivePanel] = useState("1");
  const [showModal, setShowModal] = useState(false);
  const [trade, setTrade] = useState<ITrade>(null);
  const [requiredDocumentUpload, setRequiredDocumentUpload] = useState(true);
  const [requiredInstallmentReceiptUpload, setRequiredInstallmentReceiptUpload] = useState(true);
  const [showPreferredInstallmentComponents, setShowPreferredInstallmentComponents] = useState<any>(false);
  const [processDocument, setProcessDocument] = useState<IFileToUpload>(null);
  const [processInstallmentReceipt, setProcessInstallmentReceipt] = useState<IFileToUpload>(null);
  const [featureToggle, setFeatureToggle] = useState<IFeatureToggleConfig>(undefined);
  const [disableOficioUpload, setDisableOficioUpload] = useState(true)
  const [disableFields, setDisabledFields] = useState(true)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validatePssAndShowMessage(precatorioRequest.isPss, precatorioRequest.principal, precatorioRequest.pssAbsolute)) {
      return;
    }

    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      if (!errs) {
        if (invalidCpfCnpj) {
          return notification.error({
            message: "Falha ao avançar!",
            description: "O CPF é inválido"
          });
        }
        setLoading(true);
        if (!isHonorarios) {
          precatorioRequest.credorBirthDate = undefined
        }

        if (precatorioRequest.tradeId) {
          pricingService
            .updatePrecatorioPricing(precatorioRequest)
            .then(res => {
              if (processDocument) {
                precatorioService
                  .putUploadProcessDocument({
                    precatorioId: precatorioRequest.id,
                    file: processDocument.file,
                    type: processDocument.type
                  })
                  .then(resp => {
                    notification.success({
                      description: "O precatório foi salvo com sucesso!",
                      message: "Registro salvo com sucesso"
                    });
                  })
                  .catch(err => {
                    notification.error({
                      description: err?.response?.data?.message ?? "Não foi possível salvar os dados informados.",
                      message: "Erro ao salvar as informações "
                    });
                  })
                  .finally(() => {
                    setLoading(false);
                    window.scrollTo(0, 0);
                  });
              }
              if (processInstallmentReceipt?.file != null) {
                precatorioService
                  .putUploadProcessDocument({
                    precatorioId: precatorioRequest.id,
                    file: processInstallmentReceipt.file,
                    type: processInstallmentReceipt.type
                  })
              }
              notification.success({
                description: "O precatório foi salvo com sucesso!",
                message: "Registro salvo com sucesso"
              });
              setPrecatorioRequest(precatorioRequest);
              setQuote(res.data);
              getTrade(precatorioRequest.tradeId);
            })
            .catch(err => {
              notification.error({
                description: err?.response?.data?.message ?? "Não foi possível salvar os dados informados.",
                message: "Erro ao salvar as informações"
              });
            })
            .finally(() => {
              setLoading(false);
              window.scrollTo(0, 0);
            });
        } else {
          quoteService
            .postSaveManual(precatorioRequest)
            .then(res => {
              console.log("Recibo da parcela -", processInstallmentReceipt);
              console.log("Ofóicio -", processDocument);
              if (requiredDocumentUpload) {
                precatorioService
                  .putUploadProcessDocument({
                    precatorioId: res.data.precatorio.id,
                    file: processDocument.file,
                    type: processDocument.type
                  })
              }
              if (processInstallmentReceipt?.file != null) {
                precatorioService
                  .putUploadProcessDocument({
                    precatorioId: precatorioRequest.id,
                    file: processInstallmentReceipt.file,
                    type: processInstallmentReceipt.type
                  })
              }
              notification.success({
                description: "O precatório foi salvo com sucesso!",
                message: "Registro salvo com sucesso"
              });
              props.history.push(`/monitor/cotacoes/${res.data.id}`);
              setPrecatorioRequest(precatorioRequest);
              setQuote(res.data);
              setActivePanel("2");
            })
            .catch(err => {
              console.log(err);
              notification.error({
                description: err?.response?.data?.message ?? "Não foi possível salvar os dados informados.",
                message: "Erro ao salvar as informações"
              });
            })
            .finally(() => {
              setLoading(false);
              window.scrollTo(0, 0);
            });
        }
      }
    });
  };

  useEffect(() => {
    commonDomainService.getFeatureToggleConfig().then(setFeatureToggle).catch(console.error)

    if (props.match.params.precatorioId !== "new") {
      getPrecatorioById(props.match.params.precatorioId);
    }

    if (precatorioRequest.cpfCnpj) {
      if (cpfCnpjValidator(precatorioRequest.cpfCnpj.substring(0, 18))) {
        setInvalidCpfCnpj(false);
      } else {
        setInvalidCpfCnpj(true);
      }
    }
  }, []);

  useEffect(() => {
    if (precatorioRequest.state) {
      const newState = EstadosECidades.find(c => c.uf === precatorioRequest.state || c.nome === precatorioRequest.state);
      setCities(newState?.cidades);
    }
  }, [precatorioRequest.state]);

  useEffect(() => {
    setDisableOficioUpload(!precatorioRequest.tradeId && (!precatorioRequest.courtId || !precatorioRequest.courtTypeId))
    if (precatorioRequest.tradeId) {
      setDisabledFields(false)
    }
  }, [precatorioRequest.courtId, precatorioRequest.courtTypeId, precatorioRequest.tradeId])

  const Option = Select.Option;

  const getPrecatorioById = (id: number) => {
    setLoading(true);
    precatorioService
      .getById(id)
      .then(resp => {
        setShowPreferredInstallmentComponents(resp.preferredInstallment != null);
        setPrecatorioRequest(resp);
        setRequiredDocumentUpload(false);
        setRequiredInstallmentReceiptUpload(false);
      })
      .catch(ex => ShowNotification.Error("Não foi possivel buscar o precatorio", "Tente novamente mais tarde"))
      .finally(() => setLoading(false));
  };

  function getTrade(idTrade: number) {
    tradeSearchService.getTradeDetail(idTrade)
      .then(resp => {
        setTrade(resp);
        setShowModal(true);
        setRequiredDocumentUpload(false);
        setRequiredInstallmentReceiptUpload(false);
      })
      .catch(ex => ShowNotification.Error("Não foi possivel buscar o trade", "Tente novamente mais tarde"))
      .finally(() => setLoading(false));
  }

  function setPreferredInstallment(hasPreferredInstallment: boolean) {
    if (!hasPreferredInstallment) {
      precatorioRequest.preferredInstallment = null;
    }
  }

  function acceptQuote() {
    tradeService
      .postCreateFromQuote(quote)
      .then(result => {
        props.history.push(`/venda/${result.id}`, {
          trade: result
        });
      })

      .catch(error => {
        notification.error({
          message: "Erro durante o processo de venda.",
          description: "Não foi possível prosseguir com o processo de venda. Por favor tente novamente, ou entre em contato conosco."
        });
      });
  }

  const requestOCR = async (fileToUpload: IFileToUpload) => {
    try {
      if (featureToggle.activeOCROficio) {
        setLoading(true)
        const precatorioCreateOrUpdateDto = await precatorioService.processOficio<IPrecatorioCreateOrUpdateOfficerDto>({
          courtId: precatorioRequest.courtId,
          file: {
            name: fileToUpload.name,
            base64: fileToUpload.file
          }
        })

        handlePrecatorioRequestChange(precatorioCreateOrUpdateDto)
      }
    } catch {
      ShowNotification.Warn(
        "Não foi possível realizar o preenchimento automático!",
        "Devido as limitações atuais não foi possível realizar a extração e preenchimento das informações com base no tribunal e ofício fornecido. Por favor, prossiga com o preenchimento manualmente."
      )
    } finally {
      handleChange(fileToUpload)
      setDisabledFields(false)
      setLoading(false)
    }
  }

  function handleChange(fileToUpload: IFileToUpload) {
    fileToUpload.type = "ProcessDocument";
    setProcessDocument(fileToUpload);
  }

  function handleChangeInstallmentReceipt(fileToUpload: IFileToUpload) {
    fileToUpload.type = "ProcessInstallmentReceipt";
    setProcessInstallmentReceipt(fileToUpload);
  }

  type handleValueType = (v: IPrecatorioCreateOrUpdateOfficerDto) => Partial<IPrecatorioCreateOrUpdateOfficerDto>
  const handlePrecatorioRequestChange = (value: Partial<IPrecatorioCreateOrUpdateOfficerDto> | handleValueType) => {
    setPrecatorioRequest(p => objectPropsUpdate(p, _.isFunction(value) ? value(p) : value))
  };

  return (
    <Collapse bordered={false} destroyInactivePanel activeKey={activePanel}>
      <Collapse.Panel style={{ border: "none" }} header="" key="1" showArrow={false}>
        <div className="bank-info">
          <Title size="h3" preset="bolder">
            Cadastro de Precatório
          </Title>
          <PbrSeparator />
          <div className="precatorios">
            <Spin spinning={loading}>
              <Form onSubmit={e => handleSubmit(e)}>
                <Title style={{ marginBottom: "27px" }} preset="bolder" size={"h4"}>
                  Novo Precatório
                </Title>
                <Row gutter={16}>
                  <SelectCourtAndCourtType
                    filledFields={false}
                    colLgSize={12}
                    colMdSize={12}
                    onChangeCourt={(id) => handlePrecatorioRequestChange({ courtId: id })}
                    onChangeCourtType={(id) => handlePrecatorioRequestChange({ courtTypeId: id })}
                    courtTypeId={precatorioRequest.courtTypeId}
                    courtId={precatorioRequest.courtId}
                    showCorrectionType
                    isTypeRequired
                    isCourtRequired
                    form={props.form}
                  />
                </Row>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <Tooltip title="É necessário selecionar um tribunal antes de fazer upload do ofício" placement="right">
                      <div className="upload-oficio">
                        <PbrProcessDocumentUploader
                          disabled={disableOficioUpload}
                          isRequired={requiredDocumentUpload}
                          btnText="Subir Ofício"
                          btnOfficer
                          defaultValue={processDocument}
                          subTitle="Ofício Requisitório"
                          onChangeBase64={val => {
                            requestOCR(val)
                          }}
                          style={{ textAlign: "center" }}
                          name="upload"
                        />
                      </div>
                    </Tooltip>
                  </Col>
                </Row>

                <Divider orientation="left">Necessário preencher os campos acima antes de prosseguir</Divider>

                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrInputCpf
                      disabled={disableFields}
                      formWrapper={props.form}
                      name={"cpf"}
                      value={precatorioRequest.cpfCnpj}
                      title="CPF"
                      placeholder="Informe o CPF/CNPJ"
                      formItemProps={{ label: "CPF/CNPJ" }}
                      onChange={e => handlePrecatorioRequestChange({ cpfCnpj: e.target.value })}
                      rules={[{ required: true, message: "Informe o CPF/CNPJ" }]}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrInput
                      disabled={disableFields}
                      value={precatorioRequest.requester}
                      onChange={e => handlePrecatorioRequestChange({ requester: e.target.value })}
                      name="requester"
                      title="Requerente"
                      formItemProps={{ label: "Requerente" }}
                      placeholder="Digite o Requerente do Processo"
                      formWrapper={props.form}
                      rules={[{ required: true, message: "Informe o Requerente do Processo" }]}
                    />
                  </Col>
                </Row>
                {GetPersonType(precatorioRequest?.cpfCnpj) === PersonTypeEnum.PF &&
                  <Row>
                    {featureToggle?.activateBirthDate ?
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <BirthDateComponent
                          disabled={disableFields}
                          name="birthDate"
                          request={precatorioRequest.birthDate}
                          onChange={e => handlePrecatorioRequestChange({ birthDate: e })}
                          form={props.form}
                          label="Data de nascimento do Requerente"
                          required
                        />
                      </Col> :
                      <></>}
                    {featureToggle?.activateSeriousIllness ?
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <PbrFormItem label="Possui doença grave?" required>
                          <Switch
                            disabled={disableFields}
                            checkedChildren="Sim"
                            unCheckedChildren="Não"
                            checked={precatorioRequest.isSeriousIllness}
                            onChange={e => handlePrecatorioRequestChange({ isSeriousIllness: e })}
                          />
                        </PbrFormItem>
                      </Col> :
                      <></>}
                  </Row>}
                <Row gutter={16}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <PbrFormItem label="Aquisição refere-se a honorários contratuais?">
                      <Switch
                        disabled={disableFields}
                        checkedChildren="Sim"
                        unCheckedChildren="Não"
                        checked={isHonorarios}
                        onChange={e => setIsHonorarios(e)}
                      />
                    </PbrFormItem>
                  </Col>
                  {isHonorarios &&
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <BirthDateComponent
                        disabled={disableFields}
                        name="credorBirthDate"
                        request={precatorioRequest.credorBirthDate}
                        onChange={e => handlePrecatorioRequestChange({ credorBirthDate: e })}
                        form={props.form}
                        label="Data de nascimento do credor"
                        required
                      />
                    </Col>
                  }
                </Row>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrInput
                      disabled={disableFields}
                      value={precatorioRequest.requered}
                      onChange={e => handlePrecatorioRequestChange({ requered: e.target.value })}
                      name="requered"
                      title="Requerido"
                      formItemProps={{ label: "Requerido" }}
                      placeholder="Digite o Requerido do Processo"
                      formWrapper={props.form}
                      rules={[{ required: true, message: "Informe o Requerido do Processo" }]}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <SelectNature
                      disabled={disableFields}
                      value={precatorioRequest?.natureId}
                      onChange={nature => setPrecatorioRequest({ ...precatorioRequest, natureId: nature.id })}
                      form={props.form}
                      isNatureRequired
                    />
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrInput
                      disabled={disableFields}
                      value={precatorioRequest.civilCourt}
                      onChange={e => handlePrecatorioRequestChange({ civilCourt: e.target.value })}
                      name="civilCourt"
                      title="Vara"
                      formItemProps={{ label: "Vara" }}
                      placeholder="Digite a Vara"
                      formWrapper={props.form}
                      rules={[{ required: true, message: "Informe a Vara do Precatório" }]}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <SelecExpeditionType
                      disabled={disableFields}
                      value={precatorioRequest.precatorioExpeditionType}
                      onChange={e => handlePrecatorioRequestChange({ precatorioExpeditionType: e })}
                      form={props.form}
                      required
                    />
                  </Col>
                </Row>

                <Row gutter={30}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrSelect
                      disabled={disableFields}
                      name="estado"
                      size="large"
                      formItemProps={{ label: "Estado" }}
                      formWrapper={props.form}
                      showSearch
                      value={precatorioRequest.state}
                      onChange={e => {
                        handlePrecatorioRequestChange({ state: e.toString(), city: "" });
                        props.form.setFieldsValue({
                          city: ""
                        });
                      }}
                      placeholder="Selecione o estado"
                      rules={[{ required: true, message: "Informe o estado do Precatório" }]}
                    >
                      <Option key={"none"} value="">
                        Selecione o estado
                      </Option>
                      {EstadosECidades.map((e, i) => (
                        <Option key={i.toString()} value={e.uf}>{`${e.nome}`}</Option>
                      ))}
                    </PbrSelect>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <PbrSelect
                      disabled={disableFields}
                      name="city"
                      size="large"
                      formItemProps={{ label: "Cidade" }}
                      formWrapper={props.form}
                      showSearch
                      value={precatorioRequest.city}
                      onChange={e => handlePrecatorioRequestChange({ city: e.toString() })}
                      placeholder="Selecione a cidade"
                      rules={[{ required: true, message: "Informe a cidade do Precatório" }]}

                    >
                      <Option key={"none"} value="">
                        Selecione a cidade
                      </Option>
                      {cities?.map((e, i) => (
                        <Option key={i.toString()} value={e.nome}>{`${e.nome}`}</Option>
                      ))}
                    </PbrSelect>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <BaseDateComponent request={precatorioRequest} onChange={handlePrecatorioRequestChange} form={props.form} disabled={disableFields} />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12}>
                    <IssueDateComponent request={precatorioRequest} onChange={handlePrecatorioRequestChange} form={props.form} disabled={disableFields} />
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={8} sm={8} md={8} lg={12}>
                    <PbrInputMoney
                      disabled={disableFields}
                      name="Principal"
                      formWrapper={props.form}
                      formItemProps={{ label: "Principal" }}
                      placeholder="Digite o Valor do Principal"
                      value={precatorioRequest.principal}
                      onChange={e => handlePrecatorioRequestChange({ principal: e })}
                      rules={[{ required: true, message: "Informe o Principal do Precatório" }]}
                      required={true}
                    />
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={12}>
                    <PbrInputMoney
                      disabled={disableFields}
                      name="Juros"
                      formWrapper={props.form}
                      formItemProps={{ label: "Juros" }}
                      placeholder="Digite o valor dos juros;"
                      value={precatorioRequest.interest}
                      onChange={e => handlePrecatorioRequestChange({ interest: e })}
                      rules={[{ required: true, message: "Informe o Principal do Precatório" }]}
                    />
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={8} sm={8} md={8} lg={8}>
                    <PbrInput
                      disabled={disableFields}
                      value={precatorioRequest.processCode}
                      formItemProps={{ label: "Número do Precatório" }}
                      onChange={e => handlePrecatorioRequestChange({ processCode: e.target.value })}
                      name="processCode"
                      placeholder="Digite o Número do Precatório"
                      formWrapper={props.form}
                      rules={[{ required: true, message: "Campo obrigatório" }]}
                    />
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={8}>
                    <PbrInputCNJ
                      disabled={disableFields}
                      value={precatorioRequest.processCodeSource}
                      onChange={e => handlePrecatorioRequestChange({ processCodeSource: e.target.value })}
                      name="processCodeSource"
                      title="Código do Processo de Origem"
                      placeholder="Digite o Código do Processo"
                      formWrapper={props.form}
                      required
                    />
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={8}>
                    <PbrInputCNJ
                      disabled={disableFields}
                      value={precatorioRequest.sentenceCode}
                      onChange={e => handlePrecatorioRequestChange({ sentenceCode: e.target.value })}
                      name="sentenceCode"
                      title="Cumprimento de Sentença"
                      placeholder="Digite o Código da Sentença"
                      formWrapper={props.form}
                    />
                  </Col>
                </Row>
                {precatorioRequest.tradeId &&
                  <Modal className="modal-view-trade-commission" title="Editar Comissão" visible={showModal} footer={[]} onCancel={() => setShowModal(false)} maskClosable={false}>
                    {showModal &&
                      <ViewCommissionModal
                        currentTrade={trade}
                        onCommissionUpdated={(currentTrade) => {
                          getTrade(currentTrade.id)
                          setShowModal(false)
                          props.history.goBack()
                        }}
                      />
                    }
                  </Modal>
                }
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12} style={{ textAlign: "center", paddingTop: "40px" }}>
                    <PSSComponent
                      disabled={disableFields}
                      canEditPssAbsolute={pssAbsoluteRequired(precatorioRequest.isPss, precatorioRequest.principal)}
                      canEditPssPercentual={false}
                      pssabsolute={precatorioRequest.pssAbsolute}
                      isPss={precatorioRequest.isPss}
                      onChangePssAbsolute={(pssAbsoluteParam) => handlePrecatorioRequestChange({ pssAbsolute: pssAbsoluteParam })}
                      onChangeIsPss={(isPssParam) => handlePrecatorioRequestChange({ isPss: isPssParam })}
                      form={props.form}
                      pssAbsoluteRequired={pssAbsoluteRequired(precatorioRequest.isPss, precatorioRequest.principal)} />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} style={{ textAlign: "center" }}>
                    <PbrFormItem label="Parcela preferencial já foi paga?">
                      <Switch
                        disabled={disableFields}
                        checkedChildren="Sim"
                        unCheckedChildren="Não"
                        defaultChecked
                        checked={showPreferredInstallmentComponents}
                        onChange={e => {
                          setShowPreferredInstallmentComponents(e)
                          setPreferredInstallment(e)
                        }
                        }
                      />
                    </PbrFormItem>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} style={{ textAlign: "center" }}>
                    <PbrFormItem label="Reduzir percentual do credor?">
                      <Tooltip title={precatorioRequest.isReducedPercentLender ? "Informe o percentual da compra do precatório" : "Aquisição de 100% do precatório"}>
                        <Switch
                          disabled={disableFields}
                          checkedChildren="Sim"
                          unCheckedChildren="Não"
                          checked={precatorioRequest.isReducedPercentLender}
                          onChange={e => { handlePrecatorioRequestChange({ isReducedPercentLender: e, reducedPercentLender: e ? 0.99 : 1 }) }}
                        />
                      </Tooltip>
                    </PbrFormItem>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} style={{ textAlign: "center" }}>
                    <PbrInputPercentage
                      disabled={disableFields && !precatorioRequest.isReducedPercentLender}
                      value={precatorioRequest.isReducedPercentLender ? PercentageMask(precatorioRequest.reducedPercentLender, 2, 2) : "100000%"}
                      onChange={e => handlePrecatorioRequestChange({ reducedPercentLender: (e) })}
                      name="reducedPercentLender"
                      title="reducedPercentLender"
                      formItemProps={{ label: "Percentual do Credor" }}
                      placeholder="00.00%"
                      formWrapper={props.form}
                      rules={[{ required: true, message: "Informe o Percentual Reduzido" }]}
                      mask={precatorioRequest.isReducedPercentLender ? "99.99%" : "999.99%"}
                    />
                  </Col>
                </Row>
                {showPreferredInstallmentComponents &&
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <PbrInputDate
                        disabled={disableFields}
                        name="installmentBaseDate"
                        formWrapper={props.form}
                        formItemProps={{ label: "Data de Recebimento da Parcela" }}
                        placeholder={"Data de Recebimento da Parcela"}
                        value={precatorioRequest.preferredInstallment?.baseDate}
                        onChange={e => handlePrecatorioRequestChange(p => ({ preferredInstallment: { ...p.preferredInstallment, baseDate: e } }))}
                        requiredMessage="Informe a Data de Recebimento da Parcela"
                        isRequired
                        disabledDate={current => current && current > moment(new Date()).add(-2, "days")}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: "6px" }}>
                      <PbrInputMoney
                        disabled={disableFields}
                        name="installmentPrice"
                        formWrapper={props.form}
                        formItemProps={{ label: "Valor do Recebimento da Parcela" }}
                        placeholder="Valor do Recebimento da Parcela"
                        value={precatorioRequest.preferredInstallment?.price}
                        onChange={e => handlePrecatorioRequestChange(p => ({ preferredInstallment: { ...p.preferredInstallment, price: e } }))}
                        rules={[{ required: true, message: "Informe o Valor do Recebimento da Parcela" }]}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <PbrProcessDocumentUploader
                        disabled={disableFields}
                        isRequired={requiredInstallmentReceiptUpload}
                        btnText="Enviar Alvará/Comprovante"
                        btnOfficer
                        defaultValue={processInstallmentReceipt}
                        subTitle="Alvará/Comprovante"
                        onChangeBase64={val => handleChangeInstallmentReceipt(val)}
                        style={{ textAlign: "center" }}
                        name="uploadInstallmentReceipt"
                      />
                    </Col>
                  </Row>
                }

                <Row gutter={16} className="actions-btn-row">
                  <Col sm={24} md={24} lg={12} xl={12} style={{ textAlign: "right", paddingTop: "20px" }}>
                    <Link to="/monitor/precatorios/list/">
                      <StandardButton disabled={disableFields} preset="outline">Voltar</StandardButton>
                    </Link>
                  </Col>
                  <Col sm={24} md={24} lg={12} xl={12} style={{ paddingTop: "20px" }}>
                    <StandardButton disabled={disableFields} htmlType="submit" loading={loading}>
                      Salvar
                    </StandardButton>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </div>
        </div>
      </Collapse.Panel>
      <Collapse.Panel
        className="quote"
        style={{ border: "none", maxWidth: "800px", marginLeft: "auto", marginRight: "auto" }}
        header=""
        key="2"
        showArrow={false}
      >
        <MonitorPrecatoriosQuoteResult precatorio={precatorioRequest} quote={quote} />
        <PbrSeparator />
        <Row gutter={16} className="actions-btn-row">
          <Col xs={24} sm={24} md={12} lg={12}>
            <StandardButton preset="outline" onClick={() => setActivePanel("1")}>
              Voltar
            </StandardButton>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <StandardButton onClick={() => acceptQuote()}>Prosseguir venda</StandardButton>
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse >
  );
}

export default withRouter(Form.create()(MonitorPrecatoriosCreateOrUpdate));



// WEBPACK FOOTER //
// ./src/pages/monitor/precatorios/MonitorPrecatoriosCreateNewOrUpdate.tsx